export default __webpack_public_path__ + "static/media/checked.feb69011.png";